import { withShadowDOM } from '../../hoc';
import { SearchInput as Component } from './component';
export const SearchInput = withShadowDOM(Component);
